/**
 * @group Data
 * @summary Data API error and success messages
 * 
 * @remarks
 * This constant contains error messages and other text used in data API routes
 * for consistent error handling and user feedback.
 * 
 * @example
 * ```typescript
 * import { DATA_API_MESSAGES } from '@shared/constants';
 * 
 * if (!id) {
 *   throw new Error(DATA_API_MESSAGES.ERRORS.ID_REQUIRED);
 * }
 * 
 * return { message: DATA_API_MESSAGES.SUCCESS.SUCCESS };
 * ```
 */
export const DATA_API_MESSAGES = {
  ERRORS: {
    FETCH_DATA_ACCESS_LEVELS: 'Error fetching data access levels:',
    FETCH_PERMISSION: 'Error fetching permission:',
    INTERNAL_SERVER: 'Internal server error',
    ID_REQUIRED: 'ID is required',
    PERMISSION_NOT_FOUND: 'Permission not found',
    BAD_REQUEST: 'Bad request'
  },
  SUCCESS: {
    SUCCESS: 'success'
  }
} as const; 